import type { MutationMeta, QueryMeta } from '@zg-rentals/react-query5';

import type { QueryTag } from '../constants/QueryTagConstants';

export function paymentsQueryMeta(
  api: string,
  details: string,
  tags: Array<QueryTag> = [],
  base: QueryMeta = {},
): QueryMeta {
  return { ...base, tags: [...(base.tags ?? []), ...tags], context: { ...base.context, api, details } };
}

export function paymentsMutationMeta(
  api: string,
  details: string,
  invalidates: Array<QueryTag> = [],
  base: MutationMeta = {},
): MutationMeta {
  return {
    ...base,
    invalidates: [...(base.invalidates ?? []), ...invalidates],
    context: { ...base.context, api, details },
  };
}
